<template>
    <div class="loader-container clearfix" :class="'loader-' + size">
        <div class="loader"></div>
    </div>
</template>
<script>
    export default {
        props: {
            size: {
                type: String,
                required: false,
                default: 'md'
            },
        },
    }
</script>
<style lang="scss">
    $animation-duration: 1.8s;
    $color1: #009DFA;
    $color2: #dc3545;
    $color3: #ffc107;

    .loader-container {
        display: block;
        position: relative;
        height: 60px;


        .loader {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px;
            margin-left: -25px;
            height: 10px;
            background: $color1;
            border-radius: 5px;
            animation: load $animation-duration ease-in-out infinite;

            &:before, &:after {
                position: absolute;
                display: block;
                content: "";
                animation: load $animation-duration ease-in-out infinite;
                height: 10px;
                border-radius: 5px;
            }

            &:before {
                top: -20px;
                left: 10px;
                width: 40px;
                background: $color2;
            }

            &:after {
                bottom: -20px;
                width: 35px;
                background: #F5AB35;
            }
        }

        @keyframes load {
            0% {
                transform: translateX(40px);
            }
            50% {
                transform: translateX(-30px);
            }
            100% {
                transform: translateX(40px);
            }
        }

        // Extra small
        &.loader-xs {
            height: 35px;

            .loader {
                width: 25px;
                margin-left: -12.5px;
                height: 5px;
                animation: loadXs $animation-duration ease-in-out infinite;

                &:before,
                &:after {
                    height: 5px;
                    border-radius: 2.5px;
                    animation: loadXs $animation-duration ease-in-out infinite;
                }

                &:before {
                    top: -10px;
                    left: 5px;
                    width: 20px;
                }

                &:after {
                    bottom: -10px;
                    width: 17px;
                }
            }

            @keyframes loadXs {
                0% {
                    transform: translateX(10px);
                }
                50% {
                    transform: translateX(-10px);
                }
                100% {
                    transform: translateX(10px);
                }
            }
        }


        // Extra Extra small
        &.loader-xxs {
            height: 18px;

            .loader {
                width: 12.5px;
                margin-left: -6px;
                height: 3px;
                animation: loadXXs $animation-duration ease-in-out infinite;

                &:before,
                &:after {
                    height: 3px;
                    border-radius: 1.5px;
                    animation: loadXXs $animation-duration ease-in-out infinite;
                }

                &:before {
                    top: -5px;
                    left: 2px;
                    width: 10px;
                }

                &:after {
                    bottom: -5px;
                    width: 8px;
                }
            }

            @keyframes loadXXs {
                0% {
                    transform: translateX(5px);
                }
                50% {
                    transform: translateX(-5px);
                }
                100% {
                    transform: translateX(5px);
                }
            }
        }
    }

</style>




// WEBPACK FOOTER //
// src/core/Components/loading.vue